import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { noteOn5 } from './constants';
import { getTone, grey } from '../../../../theme/tones';

/**
 * Note sur 5 dérivée du pourcentage (100 % = 5). Affichée partout où le score
 * apparaît — KPI global, cartes de session et tableau — pour que la même
 * grandeur se lise de la même façon d'un écran à l'autre.
 */
const StarRating = ({ percent, size = '0.78rem', color = grey(900), iconSize }) => {
  const note = noteOn5(percent);
  if (note === null) return null;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.35 }}>
      <StarRoundedIcon sx={{ fontSize: iconSize || size, color: 'warning.main' }} />
      <Typography component="span" sx={{ fontWeight: 900, fontSize: size, color, lineHeight: 1 }}>
        {note.toFixed(1)}
        <Typography component="span" sx={{ fontWeight: 700, fontSize: '0.85em', color: 'text.disabled' }}>
          /5
        </Typography>
      </Typography>
    </Box>
  );
};

StarRating.propTypes = {
  percent: PropTypes.number,
  size: PropTypes.string,
  color: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default StarRating;
